module.exports = __webpack_public_path__ + "static/actCard.d372d064.png";